import React from 'react';
import TabellaGenerale from '../TabellaGenerale';

function AreaSuccessioni() {
    return (
        <TabellaGenerale titolo="Area successioni" url="areasuccessioni" nome="Successioni" numTabella={3} />
    );
};

export default AreaSuccessioni;